module.exports = __webpack_public_path__ + "static/caddy-cargo-dac83ed95bc4b8502a310ba242726840.png";